import type { ApiResponse } from '../ApiProvider';
import Api from '../ApiProvider';

export type TokenPeriod = 'day' | 'week' | 'month' | 'year' | 'all';

type TokenPriceHistoryDto = {
  history: { price: number; time: string }[];
  percent_change: null | number;
  symbol: string;
  icon: string;
};

type TokenPriceHistory = {
  history: { price: number; timestamp: number }[];
  percentChange: null | number;
  symbol: string;
  icon: string;
};

export const getTokenPriceHistory = async (
  idOrSlug: string | number,
  period: TokenPeriod,
): Promise<TokenPriceHistory> => {
  const { payload } = await Api.get(`v2/quote/coins/${idOrSlug}/price-history`, {
    searchParams: { period },
  }).json<ApiResponse<TokenPriceHistoryDto>>();

  return {
    history: payload.history.map((item) => ({
      price: item.price,
      timestamp: new Date(item.time).valueOf(),
    })),
    percentChange: payload.percent_change,
    symbol: payload.symbol,
    icon: payload.icon,
  };
};
